module.exports = __webpack_public_path__ + "static/media/bedroom.499d31ff.jpg";